import { zipRegex } from 'utils/regexes';

/**
 * @function isValidZipCode
 * @param {string} value
 * @return {boolean}
 */
export const isValidZipCode = (value) => zipRegex.test(value);
